<script setup>

import { defineProps} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra"
]);

//==================================================================//
//========================= Parcelas Header ========================//
//==================================================================//

let parcelasHeaders = [
    { text: 'Codigo',               value: 'codigo',            class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"88px"},
    { text: 'Tipo',                 value: 'tipo',              class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"180px"},
    { text: 'Descrição',            value: 'descricao',         class:"c-parcelas__header",    cellClass:'c-parcelas__cell'},
    { text: 'Data Entrega',         value: 'dataEntrega',       class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"150px"},
    { text: 'Dias',                 value: 'diasVencimento',    class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"150px"},
    { text: 'Data Vencimento',      value: 'dataVencimento',    class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"150px"},
    { text: 'Percentual',           value: 'percentual',        class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"150px"},
    { text: 'Valor da Parcela',     value: 'valor',             class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"150px"},
    { text: 'Referência Evento',    value: 'referenciaEvento',  class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"210px"},
]

//==================================================================//
//=========================== Clamp Valor ==========================//
//==================================================================//

const clampValor = (valor,min,max) =>{

    return Math.min(Math.max(valor, min), max);

};

//==================================================================//
//=================== Valor Monetario Formatado ====================//
//==================================================================//

const valorMonetarioFormatado = (valor = 0)=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(clampValor(valor,-999999999,999999999));

};

</script>

<template>

    <v-card
        class="c-parcelas"
    >

        <v-card-title
            class="c-parcelas__titulo"
        >
        
            <h3>Parcelas</h3>

        </v-card-title>

        <div
            class="c-parcelas__conteudo"
        >

            <v-data-table
                class="c-parcelas__tabela elevation-1"
                :headers="parcelasHeaders"
                :items="props.pedidoDeCompra.parcelas"
                :items-per-page="-1"
                item-key="id"
            >

                <template v-slot:item.percentual="{ item }">

                    {{item.percentual}}%

                </template>

                <template v-slot:item.valor="{ item }">

                    R$ {{valorMonetarioFormatado(item?.valor)}}

                </template>

            </v-data-table>

        </div>

    </v-card>


</template>

<style scoped>

.c-parcelas__tabela{
    display: grid;
    white-space: nowrap;
}

</style>